import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=0606dd62&scoped=true"
import script from "./cta.vue?vue&type=script&lang=ts"
export * from "./cta.vue?vue&type=script&lang=ts"
import style0 from "./cta.vue?vue&type=style&index=0&id=0606dd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606dd62",
  null
  
)

export default component.exports